// extracted by mini-css-extract-plugin
export default {"modal":"PhotoModal_modal__FAkGO","modalContent":"PhotoModal_modalContent__3U+wY","image":"PhotoModal_image__bb865"};